export default __webpack_public_path__ + "static/media/Kaufman.a0cd08ab.png";